
$(document).ready(function(){
  
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if(getCookie('popup') != 'true' && window.location.href.indexOf('challenge#contact_form') == -1){
    $(".custom-popup").delay(2000).show();
    //  setCookie('popup', 'true', 1);
}
/* Checkout popup START CODE  */
$(document).on('click',"#ctm-checkout_jtpl",function(){
  $(".checkout-popup").addClass('checkout_model-open');
});
if($('.checkout-popup').length == 0){
   $('#CartDrawer-Checkout').show();
  $('#ctm-checkout_jtpl').hide();
}
   
$(document).on('click',".checkout_popup-close-btn , .checkout_no-thanks-btn",function(){
   window.location.href='/checkout';
  $(".checkout-popup").removeClass('checkout_model-open');
 // $('#CartDrawer-Checkout').show();
  //$('#ctm-checkout_jtpl').hide();
 
 //setCookie('checkout_popup', 'true', 1);
});
 
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".checkout-popup-inner").length === 0 && $(".checkout-popup").hasClass('checkout_model-open')) { 
         window.location.href='/checkout';
              $(".checkout-popup").removeClass('checkout_model-open');
           // setCookie('checkout_popup', 'true', 1);
          //  $('.checkout_popup-close-btn').trigger('click');
              
            } 
        }); 

// if(getCookie('checkout_popup') == 'true' ){
//    $('.checkout-popup').removeClass('checkout_model-open');
//     $('#CartDrawer-Checkout').show();
//     $('#ctm-checkout_jtpl').hide();

// }

/* Checkout popup END CODE  */

/* Welcome PopUp START CODE */
  $(".announcement-bar__message a").click(function(e){
   if($(this).attr('href').indexOf('#') >-1){
      e.preventDefault();
      $('.custom-popup').addClass('model-open').show(); 
    }
    
   
  });
$(".popup-close-btn ,.no-thanks-btn").click(function(e){
e.preventDefault();
  $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
window.history.pushState({}, '', main_url);
  setCookie('popup', 'true', 1);
});



   $(document).mouseup(function (e) { 
    var recommended_data =  $(".recommendation-modal__container").html();
            if ($(e.target).closest(".custom-popup-inner").length === 0 && typeof recommended_data == 'undefined' ) { 
       $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
// window.history.pushState({}, '', main_url);
window.history.replaceState({}, '', main_url);
  setCookie('popup', 'true', 1);
  
              
            } 
        }); 

/*Welcome PopUp END CODE*/
 
  /** slider btn ****/
  $(window).on("load resize scroll",function(e){
var img_height = $('.about-multicol .multicolumn-card__image-wrapper').height();
var half_hight = img_height/2;
$('.about-multicol .slider-buttons').css("top",half_hight);
});
 /** slider btn End****/
 

  if($(window).width() > 1024){
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
       window.dispatchEvent(new Event("resize"));
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });
  }else{
      let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("click", () => {
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
    });
   });  
  }
              
   function eventFire(el, etype){
 console.log(el);
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
$('.mega-menu-image-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
 nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
});
  
/** One tab open at a time**/
$('.accordion details').click(function(){
      $(this).attr('open');
    $(this).parent('.accordion').siblings().find('details').removeAttr('open');
});
/** One tab open at a time END Code**/
setTimeout(() => {
    // Create a new wrapper div
    const wrapper = document.createElement('div');
    wrapper.classList.add('custom-wrapper'); // You can add a custom class here if needed

    // Select the two divs you want to wrap
    const looxRatingDiv = document.querySelector('.shopify-block.shopify-app-block');
    const priceDiv = document.querySelector('.price_cstm-sct');

    // Select the target container (product__info-container)
    const productInfoContainer = document.querySelector('.product__info-container');
    
    // Select the product title (product__title)
    const productTitle = document.querySelector('.product__title');

    // Check if all required elements exist
    if (looxRatingDiv && priceDiv && productInfoContainer && productTitle) {
        // Append the two divs to the wrapper
        wrapper.appendChild(looxRatingDiv);
        
        wrapper.appendChild(priceDiv);

        // Insert the wrapper after the product title
        productInfoContainer.insertBefore(wrapper, productTitle.nextSibling);
    } else {
        console.log('One or more elements not found.');
    }
}, 1000); // Delay of 100 milliseconds


// $(".wall-calulator").click(function () {
//   $(".success_msg , .wall_error").remove();
//   var width = $.trim($("#wallpaper-width").val());
//   var height = $.trim($("#wallpaper-height").val());
//   if (
//     width != undefined &&
//     width != "" &&
//     height != undefined &&
//     height != ""
//   ) {
//     if (isNaN(width) == true || isNaN(height) == true) {
//       $('<p class="error wall_error">Please enter a valid number</p>').insertAfter($(this));
//     } else {
//       var roll = Math.ceil(width / 24);
//       height = parseInt(height);
//       var w1 = 24;

//       if (height < 24) {
//         height = 36;
//       }

//       if (height >= 24 && height <= 36) {
//         height = 36;
//       } else if (height >= 37 && height <= 48) {
//         height = 48;
//       } else if (height >= 49 && height <= 60) {
//         height = 60;
//       } else if (height >= 61 && height <= 72) {
//         height = 72;
//       } else if (height >= 73 && height <= 84) {
//         height = 84;
//       } else if (height >= 85 && height <= 96) {
//         height = 96;
//       } else if (height >= 97 && height <= 108) {
//         height = 108;
//       } else if (height >= 109 && height <= 120) {
//         height = 120;
//       } else if (height >= 121 && height <= 132) {
//         height = 132;
//       } else if (height >= 133 && height <= 144) {
//         height = 144;
//       } else {
//         height = parseInt(height);
//       }

// var message = `<p class="success_msg">Total required is: ${roll} rolls of ${w1}"x${height}"</p>`;
// $(".wallpaper-size-calculator").append(message);

// // Update the visible dropdown label
// $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

// // ==== AUTO UPDATE SHOPIFY QUANTITY ====
// let qty = document.querySelector('.quantity__input');

// if (qty) {
//     qty.value = roll;
//     qty.dispatchEvent(new Event('input', { bubbles: true }));
//     qty.dispatchEvent(new Event('change', { bubbles: true }));
// }

// $('input[name="quantity"]').val(roll).trigger('change');

// const addBtn = document.querySelector(".product-form__submit");
// if (addBtn) {
//     addBtn.disabled = false;
//     addBtn.classList.remove("disabled");
//     addBtn.removeAttribute("aria-disabled");
// }

//       // Update the visible dropdown label
//       $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

//       // Also update the underlying select dropdown
//       var $select = $('.select__select');
//       var newVal = `${w1}"x${height}"`;

//       // Try to select option if exists
//       var optionExists = false;
//       $select.find('option').each(function () {
//         if ($(this).text() === newVal) {
//           $(this).prop('selected', true);
//           optionExists = true;
//           return false; // break loop
//         }
//       });

//       // If option doesn't exist, optionally add it
//       if (!optionExists) {
//         $select.append(new Option(newVal, newVal, true, true));
//       }
      
//       $select.val(newVal).trigger('change');
//     }
//   } else {
//     if (width == undefined || width == "") {
//       $("#wallpaper-width").parent(".field").addClass("error");
//     }
//     if (height == undefined || height == "") {
//       $("#wallpaper-height").parent(".field").addClass("error");
//     }
//     $('<p class="error wall_error">Please fill the above fields</p>').insertAfter($(this));
//   }
//    var textArray = [];

// $(".selectedOption").each(function() {
//   var text = $(this).text().trim();      
//   var firstPart = text.split('/')[0].trim(); 
//   textArray.push(firstPart);
// });

// console.log("textArray:", textArray);

// $(".form_input_variants").find("select option").each(function(index, ele) {
//   var text = $(ele).text().trim(); // Full option text
//   var value = $(ele).val();        // Option value

//   // Remove price after '-'
//   var cleaned = text.split('-')[0].trim();

//   // Split by '/'
//   var parts = cleaned.split('/');
//   if (parts.length >= 2) {
//     var part1 = parts[0].trim();
//     var part2 = parts[1].trim();

//     // Check if both part1 and part2 exist in textArray
//     if (textArray.includes(part1) && textArray.includes(part2)) {
//       console.log("Matched Option Value:", value, "Part1:", part1, "Part2:", part2);

//       // Set the value to the select element with name="id"
//       $(".variant_select_cstm").find('input[name="id"]').val(value).trigger('change');
//     }
//   }
// });
// });


$(".wall-calulator").click(function () {
$(".success_msg , .wall_error").remove();
  var width = $.trim($("#wallpaper-width").val());
  var height = $.trim($("#wallpaper-height").val());

  if (
    width != undefined &&
    width != "" &&
    height != undefined &&
    height != ""
  ) {
    if (isNaN(width) == true || isNaN(height) == true) {
      $('<p class="error wall_error">Please enter a valid number</p>').insertAfter($(this));
    } else {
      var roll = Math.ceil(width / 24);
      height = parseInt(height);
      var w1 = 24;

      if (height < 24) {
        height = 36;
      }

      if (height >= 24 && height <= 36) {
        height = 36;
      } else if (height >= 37 && height <= 48) {
        height = 48;
      } else if (height >= 49 && height <= 60) {
        height = 60;
      } else if (height >= 61 && height <= 72) {
        height = 72;
      } else if (height >= 73 && height <= 84) {
        height = 84;
      } else if (height >= 85 && height <= 96) {
        height = 96;
      } else if (height >= 97 && height <= 108) {
        height = 108;
      } else if (height >= 109 && height <= 120) {
        height = 120;
      } else if (height >= 121 && height <= 132) {
        height = 132;
      } else if (height >= 133 && height <= 144) {
        height = 144;
      } else {
        height = parseInt(height);
      }
var message = `<p class="success_msg">Total required is: ${roll} rolls of ${w1}"x${height}"</p>`;
$("#calculatorPopup .wallpaper-size-calculator-popup .contact__button").append(message);

$("#wallpaper_calculator .wallpaper_cal_wrapper .contact__button").append(message);
$(".custm-hotel-motel-landing .wallpaper_cal_wrapper .contact__button").append(message);
// Update the visible dropdown label
$('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

// ==== AUTO UPDATE SHOPIFY QUANTITY ====
let qty = document.querySelector('.quantity__input');

if (qty) {
    qty.value = roll;
    qty.dispatchEvent(new Event('input', { bubbles: true }));
    qty.dispatchEvent(new Event('change', { bubbles: true }));
}

$('input[name="quantity"]').val(roll).trigger('change');

const addBtn = document.querySelector(".product-form__submit");
if (addBtn) {
    addBtn.disabled = false;
    addBtn.classList.remove("disabled");
    addBtn.removeAttribute("aria-disabled");
}

      // Update the visible dropdown label
      $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

      // Also update the underlying select dropdown
      var $select = $('.select__select');
      var newVal = `${w1}"x${height}"`;

      // Try to select option if exists
      var optionExists = false;
      $select.find('option').each(function () {
        if ($(this).text() === newVal) {
          $(this).prop('selected', true);
          optionExists = true;
          return false; // break loop
        }
      });

      // If option doesn't exist, optionally add it
      if (!optionExists) {
        $select.append(new Option(newVal, newVal, true, true));
      }
      
      $select.val(newVal).trigger('change');
    }
  } else {
    if (width == undefined || width == "") {
      $("#wallpaper-width").parent(".field").addClass("error");
    }
    if (height == undefined || height == "") {
      $("#wallpaper-height").parent(".field").addClass("error");
    }
    $('<p class="error wall_error">Please fill the above fields</p>').insertAfter($(this));
  }
   var textArray = [];

$(".selectedOption").each(function() {
  var text = $(this).text().trim();      
  var firstPart = text.split('/')[0].trim(); 
  textArray.push(firstPart);
});

// console.log("textArray:", textArray);

$(".form_input_variants").find("select option").each(function(index, ele) {
  var text = $(ele).text().trim(); // Full option text
  var value = $(ele).val();        // Option value

  // Remove price after '-'
  var cleaned = text.split('-')[0].trim();

  // Split by '/'
  var parts = cleaned.split('/');
  if (parts.length >= 2) {
    var part1 = parts[0].trim();
    var part2 = parts[1].trim();

    // Check if both part1 and part2 exist in textArray
    if (textArray.includes(part1) && textArray.includes(part2)) {
      // console.log("Matched Option Value:", value, "Part1:", part1, "Part2:", part2);

      // Set the value to the select element with name="id"
      $(".variant_select_cstm").find('input[name="id"]').val(value).trigger('change');
    }
  }
});

});



/** Add attribute to the product form**/

$('.product-form__buttons button').click(function(e){
  $(this).parents('.product-form').attr('data-type',$(this).attr('data-type'));
  
});




// $(document).on('click', '.sample_button', function (e) {
//     e.preventDefault();

//     const form = document.querySelector(".form");
//     if (form && !form.checkValidity()) {
//         form.reportValidity();
//         return;
//     }

//     const variantId = $(this).data('vid');

//     const qtyInput = document.querySelector(".quantity__input");

//     // Safely get color value
//     const colorInput = $(".additonal_color_field .field__input");
//     const color = colorInput.length ? (colorInput.val() || "").trim() : "";

//     // Step 1: Calculate roll based on width/height
//     const width = parseFloat($.trim($("#wallpaper-width").val()));
//     const height = parseFloat($.trim($("#wallpaper-height").val()));
//     let rollQty = 1; // default

//     if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
//         rollQty = Math.ceil(width / 24);
//     }

//     // Step 2: Use user input if it's valid
//     if (qtyInput) {
//         const userQty = parseInt(qtyInput.value);
//         if (!isNaN(userQty) && userQty > 0) {
//             rollQty = userQty;
//         }
//     }

//     // Step 3: Prepare fetch body
//     const bodyData = {
//         id: variantId,
//         quantity: rollQty
//     };

//     if (color) {
//         bodyData.properties = { "Color": color };
//     }

//     // Step 4: Add to cart
//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(bodyData)
//     })
//     .then(res => res.json())
//     .then(() => {
//         // Refresh cart drawer and icon bubble
//         fetch('/?sections=cart-drawer,cart-icon-bubble')
//             .then(res => res.json())
//             .then(data => {
//                 $("cart-drawer-items").html(
//                     $(data["cart-drawer"]).find("cart-drawer-items").html()
//                 );
//                 $("#cart-icon-bubble").html(
//                     $(data["cart-icon-bubble"]).html()
//                 );
//                 $("cart-drawer").removeClass("is-empty");
//                 $(".drawer__inner-empty").hide();

//                 // Ensure the drawer is fully loaded and open
//                 $("cart-drawer").load("/cart #CartDrawer", function () {
//                     document.querySelector('#cart-icon-bubble').click();
//                 });
//             });
//     });
// });


// Comment The code March 19
// $(document).on('click', '.sample_button', function (e) {
//     e.preventDefault();
 
//     const form = document.querySelector(".form");
//     if (form && !form.checkValidity()) {
//         form.reportValidity();
//         return;
//     }
 
//     const variantId = $(this).data('vid');
 
//     const qtyInput = document.querySelector(".quantity__input");
 
//     // Step 1: Calculate roll based on width/height
//     const width = parseFloat($.trim($("#wallpaper-width").val()));
//     const height = parseFloat($.trim($("#wallpaper-height").val()));
//     let rollQty = 1; // default
 
//     if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
//         rollQty = Math.ceil(width / 24);
//     }
 
//     // Step 2: Use user input if it's valid
//     if (qtyInput) {
//         const userQty = parseInt(qtyInput.value);
//         if (!isNaN(userQty) && userQty > 0) {
//             rollQty = userQty;
//         }
//     }
 
//     // ⭐ Step 3: Collect ALL line-item properties from label + input
//     let properties = {};
 
//     $(".line-item-property__field").each(function () {
//         const labelText = $(this).find("label").text().replace("*", "").trim();
//         const value = ($(this).find(".field__input").val() || "").trim();
 
//         if (labelText && value) {
//             properties[labelText] = value;
//         }
//     });
 
//     // Step 4: Prepare fetch body
//     const bodyData = {
//         id: variantId,
//         quantity: rollQty,
//         properties: properties
//     };
 
//     // Step 5: Add to cart
//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(bodyData)
//     })
//     .then(res => res.json())
//     .then(() => {
//         // Refresh cart drawer and icon bubble
//         fetch('/?sections=cart-drawer,cart-icon-bubble')
//             .then(res => res.json())
//             .then(data => {
//                 $("cart-drawer-items").html(
//                     $(data["cart-drawer"]).find("cart-drawer-items").html()
//                 );
//                 $("#cart-icon-bubble").html(
//                     $(data["cart-icon-bubble"]).html()
//                 );
//                 $("cart-drawer").removeClass("is-empty");
//                 $(".drawer__inner-empty").hide();
 
//                 // Ensure the drawer is fully loaded and open
//                 $("cart-drawer").load("/cart #CartDrawer", function () {
//                     document.querySelector('#cart-icon-bubble').click();
//                 });
//             });
//     });
// });


// Merge the code March 19
$(document).on('click', '.sample_button.product-form__submit', function (e) {
  // alert();
    e.preventDefault();
    e.stopPropagation();
    
    
      //  const colorInputRemove_2 = document.querySelector('.color_properties_1');
      //   colorInputRemove_2.required = false;
        // setTimeout(() => {
        //       colorInputRemove_2.required = true;
        //     }, 2000);



        if (document.getElementById('popup_color_picker_2')){
                      let colorInput_2 = document.getElementById('popup_color_picker_2');
            console.log(colorInput_2)
            colorInput_2.addEventListener('input', () => {
              let colorValue = colorInput_2.value.trim();

              if (colorValue !== '') {
                let existingError = document.getElementById('color-error');
                if (existingError) {
                  existingError.remove();
                }
                colorInput.style.removeProperty('border');
              }
            });
              let colorValue2 = colorInput_2.value.trim();
              let existingError = document.getElementById('color-error');
              if (existingError) {
                existingError.remove();
                colorInput_2.style.removeProperty('border');
              }

              if (colorValue2 === '') {
                let errorMsg = document.createElement('div');
                errorMsg.id = 'color-error';
                errorMsg.style.color = 'red';
                errorMsg.style.marginTop = '5px';
                errorMsg.innerText = 'Please fill the color';
                colorInput_2.parentNode.appendChild(errorMsg);

                colorInput_2.style.setProperty('border', '1px solid red', 'important');

                return;
              }
           }
          setTimeout(() => {
            let sample_popup_open = document.querySelectorAll(".sample_button");
            sample_popup_open.forEach((el) => {
                let current = Number(el.getAttribute("getpopup"));
                el.setAttribute("getpopup",0);
              });
          }, 1500);
   
    const PDP_TARGET_SELECTOR_2 = ".wallpaper-size-calculator";
      let roomvoBtn_2 = null;
      let pdpTarget_2 = null;

      function setPDPStyle_2(btn) {
        btn.innerHTML = "";
        btn.append(" See this in my room");
      }

      const observer = new MutationObserver(() => {
        roomvoBtn_2 = document.querySelector(".popup_details .popup_content .inside_popup .popup_content_1 .wallpaper_button button.roomvo-stimr.processed");
        pdpTarget_2 = document.querySelector(PDP_TARGET_SELECTOR_2);

        if (pdpTarget_2 && roomvoBtn_2) {
          pdpTarget_2.insertAdjacentElement("afterend", roomvoBtn_2);
          setPDPStyle_2(roomvoBtn_2);

          const popup = document.getElementById("pdpPopup");
          if (popup) popup.classList.remove("active");
          document.body.classList.remove("active");
          observer.disconnect(); // Stop observing once done
        }
      });

      // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      console.log("Observer stopped by timeout");
    }, 2000);
    const form = document.querySelector(".product-form .form");
    if (form && !form.checkValidity()) {
        form.reportValidity();
        return;
    }

    const variantId = $('.sample_button.product-form__submit').attr('data-vid');
    const qtyInput = document.querySelector(".quantity__input");
    const width = parseFloat($.trim($("#wallpaper-width").val()));
    const height = parseFloat($.trim($("#wallpaper-height").val()));
    let rollQty = 1; // default

    if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
        rollQty = Math.ceil(width / 24);
    }
    if (qtyInput) {
        const userQty = parseInt(qtyInput.value);
        if (!isNaN(userQty) && userQty > 0) {
            rollQty = userQty;
        }
    }
    
    let properties = {};
      // console.log("----------------properties")
  $(".line-item-property__field").each(function () {

    const $field = $(this);
    const labelText = $field.find("label").text().replace("*", "").trim();
    let value = ($field.find(".field__input").val() || "").trim();

    if (!labelText || properties[labelText]) {
        return;
    }

    // Normalize value
    if (!value || value.startsWith("#")) {
        value = "Default";
    }

    // Check popup condition once
    let shouldAssignDefault = false;

    document.querySelectorAll(".sample_button").forEach((el) => {
        const current = Number(el.getAttribute("getpopup"));

        if (current === 2) {
            properties[labelText] = value;
        } else if (current === 0 || current === 1) {
            shouldAssignDefault = true;
        }
    });

    // Handle default assignment for 0/1 case
    if (shouldAssignDefault && !properties[labelText]) {
        properties[labelText] = value === "Default" ? "Default" : "Default";
    }

    // console.log(labelText + ":", properties[labelText]);
});



    const colorValue = document.querySelector('.color_properties_1')?.value || '';
    const colorValue_sample_pdp = document.querySelector('.color_properties')?.value || '';
     let sample_popup_open = document.querySelector(".sample_button");
          let current = Number(sample_popup_open.getAttribute("getpopup")) ;
        if(colorValue){
          if(colorValue){
            properties["Color"] = colorValue;       
          }
          else if(current==1){
           properties["Color"] = colorValue;
            }
            else if(current==0 ){
              properties["Color"] ="Default"
            }

        }
            
  //  if (colorValue) {
  //   properties["Color"] = colorValue;
  // }  
    const bodyData = {
        id: variantId,
        quantity: rollQty,
        properties: properties
    };
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
    })
    .then(res => res.json())
    .then(() => {
        fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(res => res.json())
            .then(data => {
                $("cart-drawer-items").html(
                    $(data["cart-drawer"]).find("cart-drawer-items").html()
                );
                $("#cart-icon-bubble").html(
                    $(data["cart-icon-bubble"]).html()
                );
                $("cart-drawer").removeClass("is-empty");
                $(".drawer__inner-empty").hide();

                $("cart-drawer").load("/cart #CartDrawer", function () {
                    document.querySelector('#cart-icon-bubble').click();
                });
            });
    });
    return false;
});
// End the code March 19

/** Add attribute to the product form**/

$('.product-form__buttons button').click(function(e){
  $(this).parents('.product-form').attr('data-type',$(this).attr('data-type'));
  
  
});
/** Add attribute to the product form END HERE**/
    /*** convert select to ul li ***/
 

/*** product page covert select to ul li ***/

        $('.product-form__input--dropdown .select__select').each(function (index, element) {
      var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value');
      if(selected_option_val.indexOf('sample') > -1){
        var select_id= $(this).attr('id');
        $('option:selected',this).removeAttr('selected');
        $('option:eq(2)',this).attr('selected', 'selected');
        eventFire(document.getElementById(select_id), 'change');
        var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value'); 
      }
       var select_icon =$(this).next('.icon-caret');
        $(this).parent()
            .after()
            .append("<div class='scrollableList'><div class='selectedOption'></div><ul></ul></div>");
              $(select_icon).insertBefore($(this).parents('.select').find('.selectedOption'));  
        $(element).each(function (idx, elm) {
            $('option', elm).each(function (id, el) {
              if($(this).attr('data-value').indexOf('sample') == -1){
                $('.scrollableList ul:last').append('<li data-val="'+$(this).attr('data-value')+'" data-value="'+el.value+'">' + el.text + '</li>');
              }
              });
            $('.scrollableList ul').hide();
         
        });
        $('.scrollableList:last').children('div.selectedOption').text(selected_option).attr('data-selected_option_val',selected_option_val);
    });

    $('.selectedOption').on('click', function () {
        $(this).next('ul').slideToggle(200);
        $('.selectedOption').not(this).next('ul').hide();
    });

    // $('.scrollableList ul li').on('click', function () {
    //     var selectedLI = $(this).text();
    //     $(this).parent().prev('.selectedOption').text(selectedLI).attr('data-selected_option_val',$(this).attr('data-val'));
    //     $(this).parent('ul').hide();
    //   var selected_value= $(this).attr('data-val');
    //   //alert(selected_value);
    //     $(this).parents('.select').find('select option:selected').removeAttr('selected');
    //   $(this).parents('.select').find('select option[data-value="'+selected_value+'"]').attr("selected", "selected");
    //    var select_id= $(this).parents('.select').find('select').attr('id');      
    //   eventFire(document.getElementById(select_id), 'change');
    // });



    // Merge the code March 19
    $(document).on('click', '.scrollableList ul li', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var selectedLI = $(this).text();
      $(this)
          .parent()
          .prev('.selectedOption')
          .text(selectedLI)
          .attr('data-selected_option_val', $(this).attr('data-val'));

      $(this).parent('ul').hide();
      var selected_value = $(this).attr('data-val');
      let parentSelect = $(this).closest('.select');
      parentSelect.find('select option:selected').removeAttr('selected');
      parentSelect
          .find('select option[data-value="' + selected_value + '"]')
          .attr("selected", "selected");
      var select_id = parentSelect.find('select').attr('id');
      // alert(select_id);
      eventFire(document.getElementById(select_id), 'change');
      // alert(eventFire)
    });
    // End the code March 19
    $('.scrollableList').show();
    $('.select__select').hide();

  
$(document).on("click", "ul.product-option-ul .init , .dropdown-icon", function() {
  $(this).closest("ul").find('.innerLi').toggle();
});

   /*** convert select to ul li END HERE***/
  $('html').click(function(event) {
    if ($(event.target).closest('.scrollableList ul, .scrollableList').length === 0) {
        $('.scrollableList ul').hide();
    }
});
      
  // Merge the code March 19
  // let newdropdown2 = document.querySelector(".new-dropdown-2");

  // if (newdropdown2) {
  //     let scrollableList = newdropdown2.querySelector(".scrollableList");

  //     if (scrollableList) {
  //         scrollableList.addEventListener("click", function (event) {
  //             let li = event.target.closest("li");
  //             if (!li) return;

  //             let value = li.getAttribute("data-val");
  //             let text = li.getAttribute("data-value");

  //             console.log("Selected value:", value);
  //             console.log("Selected text:", text);
  //             let variant_details = document.querySelector(".variant_detail");
  //             console.log(variant_details);
  //             let variantId = null;
  //             document.querySelectorAll(".variant_id").forEach((item) => {
  //                 let title = item.getAttribute("data-title");

  //                 // Match selected text with variant title
  //                 if (title && title.includes(text)) {
  //                     variantId = item.getAttribute("data-vid");
  //                 }
  //             });
  //           let button = document.querySelector(".sample_button");
  //           console.log(button);
  //           if (button && variantId) {
  //               button.getAttribute("data-vid");
  //               button.setAttribute("data-vid",variantId)
  //           }

  //             console.log("Matched Variant ID:", variantId);
            

  //             // Optional: update real select (if needed by theme)
  //             let select = newdropdown2.querySelector("select");
  //             if (select) {
  //                 select.value = text;
  //                 select.dispatchEvent(new Event("change", { bubbles: true }));
  //             }
  //         });
  //     }
  // }
  // End the code March 19
  $(document).on("click", "ul.product-option-ul li:not(.init)", function() {
   $("ul.product-option-ul .innerLi li").removeClass('selected');
    $(this).addClass('selected');
    var selected_value = $.trim($(this).attr('data-value'));
    
    $(this).parents('ul').children('.init').html($(this).text());
  $(this).parents('ul').children('.init').attr('data-value',selected_value);    
    $(this).closest("ul").find('.innerLi').toggle();
     var select_id= $(this).parents('ul').attr('data-option'); 
  $('#SortBy option').removeAttr('selected');
  $('#SortBy option[value="'+selected_value+'"]').attr("selected", "selected");    
$('#SortBy').trigger('change');
  eventFire(document.getElementById('SortBy'), 'click');
  var url = window.location.href;
  var sort_by = 'sort_by='+selected_value;
  var href = new URL(window.location.href);
    if(window.location.href.indexOf('sort_by') > -1){
      href.searchParams.set('sort_by', selected_value);
 window.history.pushState({href: window.location.href}, '', href.toString());
      url = href.toString();
    }
    else{
       url =  url+'?'+sort_by;
         window.history.pushState({href: window.location.href}, '', url);
    }      
$.ajax({
        type: 'get',
        url:url,
        dataType: "html",
        success: function(result){ 
           $('#ProductGridContainer').html($(result).find('#ProductGridContainer'));
         
        }
    });
                 
});
  $('.sort_list').click(function(){
    $('.sort_icon').toggleClass('active');   
  });
  $('.sort_icon').click(function(){
   $('.innerLi').slideToggle();
    $('.sort_icon').toggleClass('active'); 
 });



// Prevent events from getting pass .popup
 $(document).on("click", function(event){
        var $trigger = $(".product-option-ul");
       if (!$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
        $trigger.find('.innerLi').hide();
         $trigger.find('.sort_icon').removeClass('active');
        }            
    });
});  

// Calculator label icon popup

 $(".calculator_pop").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".custom-model-inner").length === 0 ) { 
             $('.custom-model-main').removeClass('model-open');    
            } 
        }); 


